"use client";
import styled from "@emotion/styled";
import { Box, Button, Container, Link } from "@mui/material";
import Switch from "@mui/material/Switch";

const DesktopMainMenu = styled(Box)`
  /* margin-top: 10px; */
  padding: 8px 10px 8px 8px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #000000;
  max-width: 1000px;
  margin: 12px auto;
  border-radius: 15px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.02);
  @media (max-width: 1201px) {
    display: none;
  }
`;
const Imagedata = styled.img`
  width: auto;
  max-width: ${ (props) => props.mw? props.mw: '48px'}; 
  display: block;
  @media(max-width : 499px){ 
    max-width: ${ (props) => props.sw? props.sw: props.mw? props.mw: '40px'}; 
  }
`;
const MobileMainMenu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center; 

  
  @media (min-width: 1201px) {
    display: none;
  }
`;
const SiteLogo = styled.img`
  max-width: 100%;
  height: auto;
`;
const MenuLink = styled(Link)`
  font-size: 17px;
   /* font-family: 'primary2' !important; */
  color: #fff;
  /* font-weight: 600 !important; */
  text-decoration: none;
  
  padding: ${ (props) => props.p? props.p: '0 12px'};
  cursor: pointer;
  transition-duration: 0.5s; 
  z-index:${(props) => props.idex};
 /* font-weight: normal !important; */

  /* &:hover{ color: #FFBB00; } */

  @media (max-width: 1201px) {
    display: block;
    padding: ${ (props) => props.p? props.p: '15px 0 15px 0px'};
    text-align: center;
  }
`;

const CTAWrapper = styled.div`
  background: #fff;
  color: #000;
  padding: 1px 8px;
  border-radius: 12px;
  /* font-weight: 600; */
  /* box-shadow: 0 4px 12px rgba(0,0,0,0.25); */
  margin-left: 12px;
  white-space: nowrap;
  font-family: 'primary1' !important;
  a{ color: inherit; text-decoration: none; }
`;

const DrawerBox = styled(Box)`
  width: 250px;
  background: #000;
  min-height: calc( 100dvh - 0px );
  text-align: center;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

const DrawerDivider = styled.div``

const MobileDrawerBox = styled(Box)`
  width: 100vw;
  max-width: 100vw;
  height: 100dvh;
  background: linear-gradient(180deg, rgba(0,0,0,0.98) 0%, rgba(8,8,8,0.99) 100%);
  color: #fff;
  padding: 28px 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 18px;
`;

const MobileDrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MobileMenuList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 18px;
  align-items: flex-start;
`;

const MobileCTAButton = styled(Button)`
  background: #fff;
  color: #000;
  padding: 10px 18px;
  border-radius: 14px;
  font-weight: 700;
  min-width: 132px;
  align-self: flex-start;
  text-transform: none;

`;

const MenuButton = styled(Button)`
  background: #FFBB00;
  width: 30px !important;
  height: 30px !important;
  min-width: 30px;
  :hover{
    background: #FFBB00;
  }
`;

const Humburgger = styled.span`
  background: #FFBB00;
  height: 24px;
  width: 30px;
  color: #000000 !important;
  font-size: 5px;
  position: relative;
  border-radius: 1px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-top: 4px solid #FFBB00;
  border-bottom: 4px solid #FFBB00;

  &::after,&::before{
    content: 'menu';
    background: #000 !important;
    display: block;
    height: 9px;
    width: 100%;
    color: #000 !important;
  }

`;
const HumburggerClose = styled.span`
  height: 35px;
  width: 35px;
  color: transparent;
  font-size: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;

  &::after,&::before{
    content: 'menu';
    background: #1EFFAA;
    display: block;
    height: 6px;
    width: 100%;
    color: #1EFFAA;
    position: absolute;
  }
  &::before{ transform: rotate(-45deg) translate(-8px, 8px); top: 3px;}
  &::after{ transform: rotate(45deg) translate(-12px, -12px); bottom: -3px; }

`;

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be"
      }
    }
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.switchColor,
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`
    }
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2
  }
}));


export { DesktopMainMenu, MobileMainMenu, MenuLink, SiteLogo, DrawerBox, DrawerDivider, MobileDrawerBox, MobileDrawerHeader, MobileMenuList, MobileCTAButton, MenuButton, Humburgger, HumburggerClose, MaterialUISwitch, Imagedata, CTAWrapper };
